export default __webpack_public_path__ + "static/media/import.387b099a.md";